<div class="body-background-overlay" [class.scrolled]="isScrolled">
  <nav class="enhanced-navbar">
    <div class="nav-container">
      <!-- Logo Section -->
      <div class="logo-section">
        <div class="logo-wrapper">
          <img
            src="https://insizon-email-templates-bucket.s3.us-east-2.amazonaws.com/insizon/insizon-logo-v2-png.png"
            alt="Insizon Logo"
            class="logo-img" />
        </div>
      </div>

      <!-- Desktop Navigation -->
      <div class="nav-links-desktop">
        <ul class="nav-list">
          <li class="nav-item">
            <a href="/" class="nav-link">
              <span>Products</span>
              <div class="nav-underline"></div>
            </a>
          </li>
          <li class="nav-item">
            <a href="/about" class="nav-link">
              <span>About</span>
              <div class="nav-underline"></div>
            </a>
          </li>
          <li class="nav-item">
            <a href="/careers" class="nav-link">
              <span>Careers</span>
              <div class="nav-underline"></div>
            </a>
          </li>
          <li class="nav-item">
            <a href="/contact" class="nav-link">
              <span>Contact</span>
              <div class="nav-underline"></div>
            </a>
          </li>
          <li class="nav-item">
            <a href="/bug-logs" class="nav-link">
              <span>Bug-Logs</span>
              <div class="nav-underline"></div>
            </a>
          </li>
          <li class="nav-item">
            <a href="/faq" class="nav-link">
              <span>Faq</span>
              <div class="nav-underline"></div>
            </a>
          </li>
          <!-- Show Login/Register when NOT logged in -->
          <ng-container *ngIf="!(currentUser$ | async)">
            <li class="nav-item cta-item login">
              <a routerLink="/auth/login" class="nav-link cta-link">
                <span>Login</span>
                <div class="cta-glow"></div>
              </a>
            </li>
            <li class="nav-item cta-item">
              <a
                routerLink="/auth/register"
                class="nav-link cta-link register-btn">
                <span>Register</span>
                <div class="cta-glow"></div>
              </a>
            </li>
          </ng-container>

          <!-- Show User Info when logged in -->
          <ng-container *ngIf="currentUser$ | async as user">
            <li class="nav-item user-info">
              <div class="user-dropdown">
                <button class="user-button" (click)="navigateToProfile()">
                  <span class="user-name">
                    <i class="fa-regular fa-user"></i>
                  </span>
                  <span class="user-role" *ngIf="user.role">({{ user.role }})</span>
                </button>
              </div>
            </li>
            <li class="nav-item cta-item">
              <button (click)="logout()" class="nav-link cta-link logout-btn">
                <span>Logout</span>
                <div class="cta-glow"></div>
              </button>
            </li>
          </ng-container>
        </ul>
      </div>

      <!-- Mobile Menu Button -->
      <div class="mobile-menu-button" (click)="toggleMobileMenu()">
        <div class="hamburger" [class.active]="isMobileMenuOpen">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>

    <!-- Mobile Menu -->
    <div class="mobile-menu" [class.active]="isMobileMenuOpen">
      <ul class="mobile-nav-list">
        <li><a href="/" class="mobile-nav-link">Products</a></li>
        <li><a href="/about" class="mobile-nav-link">About</a></li>
        <li><a href="/careers" class="mobile-nav-link">Careers</a></li>
        <li><a href="/contact" class="mobile-nav-link">Contact</a></li>
        <li><a href="/bug-logs" class="mobile-nav-link">Bug-Logs</a></li>
        <li><a href="/faq" class="mobile-nav-link">FAQ</a></li>

        <!-- Mobile Auth Section -->
        <div class="mobile-auth-section">
          <!-- Show Login/Register when NOT logged in -->
          <ng-container *ngIf="!(currentUser$ | async)">
            <li>
              <a routerLink="/auth/register" class="mobile-nav-link mobile-cta"
                >Register</a
              >
            </li>
            <li>
              <a routerLink="/auth/login" class="mobile-nav-link mobile-cta"
                >Login</a
              >
            </li>
          </ng-container>

          <!-- Show User Info when logged in -->
          <ng-container *ngIf="currentUser$ | async as user">
            <li class="mobile-user-info">
              <div class="mobile-user-details">
                <span class="mobile-user-name">
                  <i class="fa-regular fa-user"></i>
                </span>
                <span class="mobile-user-role" *ngIf="user.role">({{ user.role }})</span>
              </div>
            </li>
            <li>
              <button (click)="logout()" class="mobile-nav-link mobile-logout">
                <i class="fa-solid fa-right-from-bracket"></i> Logout
              </button>
            </li>
          </ng-container>
        </div>
      </ul>
    </div>
  </nav>

  <!-- Floating particles for navbar -->
  <div class="nav-particles">
    <div class="particle nav-particle-1"></div>
    <div class="particle nav-particle-2"></div>
    <div class="particle nav-particle-3"></div>
  </div>
</div>
